import * as S from './IconButton.styled'
import Icon from 'components/priority/Icon/Icon'
import type { IconButtonComponentProps } from 'types/iconButton'

type ButtonPropsWithFill = IconButtonComponentProps & { fill?: string }

const IconButton = ({
  children,
  icon,
  iconLeft,
  fill,
  ...props
}: ButtonPropsWithFill) => (
  <S.Button {...props}>
    {iconLeft || icon ? (
      iconLeft ? (
        <Icon icon={iconLeft} {...(fill ? { fill } : {})} />
      ) : icon ? (
        <Icon icon={icon} {...(fill ? { fill } : {})} />
      ) : null
    ) : (
      <>
        {iconLeft && <Icon icon={iconLeft} margin="0 8px 0 0" />}
        {children}
        {icon && <Icon icon={icon} margin="0 0 0 8px" />}
      </>
    )}
  </S.Button>
)

export default IconButton
